<template>
  <span class="currency-display" :class="{ 'currency-display--small': size === 'small', 'currency-display--large': size === 'large' }">
    <span class="currency">RM</span>
    <span class="value">{{ formattedValue }}</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: { type: [Number, String], default: 0 },
  size: { type: String, default: 'default' }
})

const formattedValue = computed(() => {
  const num = Number(props.value) || 0
  return num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
})
</script>

<style scoped>
.currency-display {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}

.currency-display .currency {
  font-size: 0.85em;
  font-weight: 500;
  opacity: 0.9;
}

.currency-display .value {
  font-size: 1em;
  font-weight: 600;
}

.currency-display--small .value {
  font-size: 0.9em;
}

.currency-display--large .value {
  font-size: 1.25rem;
}
</style>
